import template from './group-confirm.component.html';
import { GroupConfirmController } from './group-confirm.controller';
import './style.less';

export const groupConfirmComponent = {
	template,
	controller: GroupConfirmController
};
